var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('div',{staticClass:"links-btn"},[_c('a',{staticClass:"btn border white",attrs:{"href":"#","id":"loginLink"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Déconnecter')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }